import { createFileRoute } from '@tanstack/react-router';
import { PageStub } from '@/components/shared/PageStub';

export const Route = createFileRoute('/alfie/insights')({
  component: () => <PageStub title="AI Insights" description="Proactive recommendations and alerts" />,
});
